import React, { useEffect, useState } from 'react'
import { ReviewerWrapper } from './Reviewer.style'
import SearchBar from 'components/comman/SearchBar/SearchBar';
import NoDataFound from 'components/comman/NoDataFoundComponent/NoDataFound';
import { Tabs, message } from 'antd';
import SecuredServices from 'api/securedServices';
import GenricModal from 'components/comman/modalComponents/modal/modal';

export default function Reviewer() {
    const [data,setData] = useState([]);
    const [missionsReviewList, setMissionsReviewList] = useState([]);
    const [selectedMission,setSelectedMission] = useState({});
    const [reviewMissionModal,setReviewMissionModal] = useState(false);
    

    useEffect(()=>{
        SecuredServices.getAllPendingMissionsForReview(1).then((res)=>{
            console.log(res.data);
            if(res.data.status==1){
                console.log(res.data.data);
                setData(res.data.data.data);
                setMissionsReviewList(res.data.data.data);
            }
        }).catch((err)=>{
            console.log(err)
        })
    },[])

    const handleSearchBarChange = (filteredData)=>{
        setMissionsReviewList(filteredData);
    }

    const handleApproveReject = (q_name,type)=>{
        let data = {
            q_name:q_name,
            isApproved:type
        }
        console.log(data);
        
        SecuredServices.reviewMissionQuestion(data).then((res)=>{
            console.log(res.data);
            if(res.data.status==1){
                message.success(res.data.message);
                //reload the page
                window.location.reload();
            }
            else{
                message.error(res.data.message);
            }
        })
    }


  return (
    <ReviewerWrapper>
           <div>
        <h3>Create Content</h3>
        <div >
            <Tabs defaultActiveKey="2" >
                <Tabs.TabPane tab="Pending" key="">
                <div className='createContentListParent'>
                  <SearchBar data={data} setFilteredData={handleSearchBarChange} />
                {missionsReviewList.length==0?<NoDataFound/>:
                  <div className='reviewList' >
                  {  
                      missionsReviewList.map((item,index)=>{
                          return <div key={index} className='reviewCard' onClick={
                            ()=>{
                                setSelectedMission(item);
                                setReviewMissionModal(true);
                            }

                        }

                            >
                            <p>{item.q_name}</p>
                          </div>
                      })
                  }
               
              </div>
                }
              
            </div>
                </Tabs.TabPane>
                </Tabs>
        </div>
          
        </div>

        <GenricModal
        closable={true}
        data={selectedMission}
        width={500}
        title={"Review Mission"}
        isOpen={reviewMissionModal}
        onClick2={handleApproveReject}
        toggle={()=>{
          setReviewMissionModal(!reviewMissionModal);
        }}
      />
    </ReviewerWrapper>
  )
}
